export default __webpack_public_path__ + "static/media/cefalea_guardia.e160e33e.pdf";